<template>
  <a
    v-if="!isMobile"
    ref="elRef"
    :href="goDetails(game.name)"
    style="cursor: pointer"
    class="flex flex-col w-[352px] h-[486px] p-4 bg-white border border-[#E6E6E6] rounded-xl"
    @click="sendDataLayer('game_click')"
  >
    <OImage loading="lazy" :src="game.thumbnail" class="w-[320px] h-[320px] rounded-md" />
    <div class="categories flex flex-row justify-center space-x-2 text-center text-[#A5A5A5] font-bold text-xs mt-4 u-center">
      <div v-for="category in displayedCategories" :key="category" class="border border-[#E6E6E6] rounded h-[22px] px-2 u-center">
        {{ category.toUpperCase() }}
      </div>
    </div>
    <h3 class="text-xl text-center text-primary-100 font-semibold mt-3">{{ truncate(game.name, { length: 33 }) }}</h3>
    <OButton color-scheme="green" class="mt-3 w-[320px] h-10 u-center">
      <span class="font-semibold text-base">{{ isPlayed ? $t('game.continue') : $t('game.play') }}</span>
    </OButton>
  </a>

  <a
    v-else
    ref="elRef"
    class="gameCard justify-between p-4 flex flex-col bg-white border border-[#E6E6E6] rounded-xl"
    :href="goDetails(game.name)"
  >
    <OImage loading="lazy" :src="game.thumbnail" class="w-full h-auto object-cover aspect-square rounded-md" />
    <h3 class="truncateText text-md font-normal text-center text-primary-100 mt-3">{{ game.name }}</h3>
    <OButton color-scheme="green" class="mt-3 h-10 w-full u-center">
      <span class="font-semibold text-base">{{ isPlayed ? $t('game.continue') : $t('game.play') }}</span>
    </OButton>
  </a>
</template>

<script>
import { defineComponent, computed, onMounted, ref } from '@nuxtjs/composition-api';
import { truncate } from 'lodash';
import { useDevice } from '~/composables/useDevice';
import { GAMES_PATH } from '~/constants/config';
import { useInfiniteScroll } from '~/composables/useInfiniteScroll';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { OButton, OImage } from '~/modules/common/components/ui';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';

export default defineComponent({
  components: { OButton, OImage },
  setup(props) {
    const { sendGameEvent } = onedioEvents();
    const { isMobile } = useDevice();
    const isPlayed = ref(false);
    const sendDataLayer = (eventAction) => {
      window.dataLayer.push({
        event: 'game_interactions',
        event_action: eventAction,
        event_label: 'Oyun - Tüm Oyunlar', // Tüm Oyunlar ya da En Sevilenler olarak değişebilir. Emojile için bu değer "Oyun - Büyük Bant" ya da "Oyun - Küçük Bant" olarak değişir.
        game_name: props.game.name, // Emojile de bu oyunlar arasındadır.
      });
      sendGameEvent('Oyunlar', 'game_click', 'Oyun - Tüm Oyunlar', props.game.name);
    };
    const getGameStatus = () => {
      return localStore.getItem(props.game.slug);
    };
    const [elRef, stopEvent] = useInfiniteScroll(
      () => {
        sendDataLayer('game_listing');
        stopEvent();
      },
      {
        threshold: 0.5,
      }
    );
    const displayedCategories = computed(() => {
      return props.game.categories.slice(0, 3);
    });
    const goDetails = (name) => {
      if (props.game.source === 'onedio' || props.game.source === 'mediazone') {
        if (name === 'Emojile' || name === 'Bilpop') {
          return `/${name.toLowerCase()}`;
        } else if (props.game.source === 'mediazone') {
          return `/${GAMES_PATH}/${props.game.slug}`;
        } else {
          return `/${props.game.slug}`;
        }
      } else {
        const url = name.replace(/\s+/g, '-').toLowerCase();
        return `/${GAMES_PATH}/${url}`;
      }
    };
    onMounted(() => {
      isPlayed.value = getGameStatus();
    });
    return { isMobile, goDetails, elRef, displayedCategories, truncate, sendDataLayer, isPlayed };
  },

  props: {
    game: {
      type: Object,
      required: true,
    },
  },
});
</script>
<style lang="scss">
.gameCard {
  width: calc(100vw / 2 - 24px);
}
.truncateText {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
